import ReportAccordion from '../common/ReportAccordion';
import { useTranslation } from 'react-i18next';
import { TraceabilityState } from '@components/Activity/types/TraceabilityState';
import { AssessorSignatureTable } from './AssessorSignatureTable';
import { DistributionListTable } from './DistributionListTable';
import { HSEUnit } from './HSEUnit';

export const TraceabilityReportAccordian = ({
  traceabilityState,
}: {
  traceabilityState: TraceabilityState;
}) => {
  const { t } = useTranslation();

  const assessors = traceabilityState.assessorList;
  const width = 200;

  return (
    <ReportAccordion header="traceability.form.details.page.container.title" noWrap>
      {traceabilityState.hseUnit && (
        <HSEUnit
          hseUnit={traceabilityState.hseUnit}
          width={width}
          signatureDate={traceabilityState.signatureDate}
        />
      )}
      <AssessorSignatureTable width={width} assessors={assessors} />
      <DistributionListTable distributionList={traceabilityState.distributionList} width={width} />
    </ReportAccordion>
  );
};
